import React from 'react';
import { Col, Row } from 'react-bootstrap';
import RangeSlider from './RangeSlider';

const RangeSliderDemo = () => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [value, setValue] = React.useState<number>();

  const handleChange = (value: number) => {
    setValue(value);
    console.log('RangeSlider selected value: ' + value);
  };

  return (
    <>
      <section className="col-6">
        <h4> Range Slider </h4>
        <Row className="py-4">
          <Col>
            <RangeSlider
              min={0}
              max={100}
              step={1}
              tooltipID="tooltip1"
              inputID="input1"
              label="What age do you want to stop working?"
              onSliderChange={handleChange}
              showRangeLabel={true}
            />
          </Col>
        </Row> 
        <Row className="py-4">
          <Col>
            <RangeSlider
              min={0}
              max={100}
              step={1}
              tooltipID="tooltip2"
              inputID="input2"
              label="What % of your income will you need at retirement?"
              onSliderChange={handleChange}
              showRangeLabel={true}
              showPercentSymbol={true}
            />
          </Col>
        </Row>              
        <Row className="py-4">
          <Col>
            <RangeSlider
              min={0}
              max={100}
              step={1}
              tooltipID="tooltip3"
              inputID="input3"
              defaultValue={30}
            />
          </Col>
        </Row>
        <Row className="py-4">
          <Col>
            <RangeSlider
              min={0}
              max={100}
              step={1}
              tooltipID="tooltip4"
              inputID="input4"
              disabled={true}
            />
          </Col>
        </Row>
      </section>
    </>
  );
};
export default RangeSliderDemo;
